import { render, staticRenderFns } from "./CompartilharTopicoSalaAula.vue?vue&type=template&id=f84ddcba&scoped=true&"
import script from "./CompartilharTopicoSalaAula.vue?vue&type=script&lang=js&"
export * from "./CompartilharTopicoSalaAula.vue?vue&type=script&lang=js&"
import style0 from "./CompartilharTopicoSalaAula.vue?vue&type=style&index=0&id=f84ddcba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84ddcba",
  null
  
)

export default component.exports